import * as React from 'react'
import {basemapHelper} from '../../helpers'
import {IDataQueriesDispatcher, ILayersDispatcher, IMapDispatcher} from '../../interfaces/dispatchers'
import {IHiddenGroupCaches} from '../../interfaces/models'
import {IDataQueries, IFeatureLayerInfos, IStore} from '../../interfaces/reducers'
import BasemapPicker from './BasemapPicker'
import LayerList from './LayerList'
import Legend from './Legend'
import Select, {SingleValue} from 'react-select'
import appConfig from '../../../reducers/appConfig'
import {} from '../../interfaces/reducers'
import Axios from 'axios'
import {getMapService} from '../../../core/reducers/map'
import {Point} from '../../../core/models'

export interface ParentProps {
  hideBasemaps?: boolean
  hideLayerList?: boolean
  hideLegend?: boolean
  layerListWithLegend?: boolean
  dataQueryDispatcher: IDataQueriesDispatcher
  currentlySelected?: string
}
export interface OwnProps {
  basemap: string
  featureLayers: IFeatureLayerInfos
  visibleLayers: {[key: string]: any}
  hiddenGroupsCaches: IHiddenGroupCaches
  zoom: number
  sourcesImported: boolean
  vectorLayerImagesLoaded: boolean
  dataQueries: IDataQueries
}

export interface DispatchProps extends IMapDispatcher, ILayersDispatcher {}

type Props = OwnProps & DispatchProps & ParentProps

interface State {
  mapKeys: any[]
  currentlySelected: string
  searchValue: string
  searchResults: any[]
  mapSearchValue: string
  pupSearch?: {[key: string]: string | undefined}
}

export class MapLayerControls extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    if (window.appType == 'public') {
      this.state = {
        mapKeys: [...basemapHelper.getOsmBasemaps(), ...basemapHelper.getEmptyMap()],
        currentlySelected: props.currentlySelected || 'basemapsControl',
        searchValue: '',
        mapSearchValue: '',
        searchResults: [],
        pupSearch: {}
      }
    } else {
      this.state = {
        mapKeys: [
          ...basemapHelper.getStamenBasemaps(),
          ...basemapHelper.getCartodbBasemaps(),
          ...basemapHelper.getOsmBasemaps(),
          ...basemapHelper.getEmptyMap(),
          ...basemapHelper.getGoogleBasemaps()
        ],
        currentlySelected: props.currentlySelected || 'basemapsControl',
        searchValue: '',
        mapSearchValue: '',
        searchResults: [],
        pupSearch: {}
      }
    }
  }

  private _restorePending = false

  componentDidMount() {
    this._restorePending = true
  }

  componentDidUpdate(prevProps: Props) {
    // Only restore after the first initialization (hiddenGroupsCaches goes empty → non-empty).
    // This handles page refresh. Navigation/tab-switch cases are handled by Legend skipping
    // re-initialization when hiddenGroupsCaches is already populated.
    if (this._restorePending && prevProps.hiddenGroupsCaches !== this.props.hiddenGroupsCaches) {
      this._restorePending = false
      try {
        const key = `gis_hidden_groups_${(window as any).appType || 'default'}`
        const savedJson = localStorage.getItem(key)
        if (savedJson) {
          const savedCache = JSON.parse(savedJson)
          if (Object.keys(savedCache).length > 0) {
            this.props.setHiddenGroupCaches(savedCache)
          }
        }
      } catch (_) {}
    }
  }

  componentWillUnmount() {
    if (
      !!(window as any).google &&
      !!(window as any).google.maps &&
      basemapHelper.getGoogleBasemaps().indexOf(this.props.basemap) != -1
    ) {
      this.props.setBasemap('osm')
    }
  }

  protected getBasemapDropdown(): JSX.Element {
    const Options = [
      {value: 'basemapsControl', label: 'Базова карта'},
      {value: 'droneControl', label: 'Собствена карта'},
      {value: 'PupControl', label: 'Промени в устройствен план'}
    ]

    return (
      <React.Fragment>
        <div className="title">Карти</div>
        <Select
          placeholder="Изберете тип карти"
          isSearchable={false}
          className="settlement-select"
          options={Options}
          onChange={(e: SingleValue<any>) => {
            if (e != null) {
              if (e.value == 'basemapsControl') {
                if (window.appType == 'public') {
                  this.setState({
                    ...this.state,
                    mapKeys: [...basemapHelper.getOsmBasemaps(), ...basemapHelper.getEmptyMap()],
                    currentlySelected: 'basemapsControl'
                  })
                } else {
                  this.setState({
                    ...this.state,
                    mapKeys: [
                      ...basemapHelper.getStamenBasemaps(),
                      ...basemapHelper.getCartodbBasemaps(),
                      ...basemapHelper.getOsmBasemaps(),
                      ...basemapHelper.getEmptyMap(),
                      ...basemapHelper.getGoogleBasemaps()
                    ],
                    currentlySelected: 'basemapsControl'
                  })
                }
              } else if (e.value == 'droneControl') {
                basemapHelper.getOwnMap().then(() => {
                  this.setState({
                    ...this.state,
                    mapKeys: [...basemapHelper.ownMaps()],
                    currentlySelected: 'droneControl'
                  })
                })
              } else if (e.value == 'PupControl') {
                basemapHelper.GetPupMaps().then(() => {
                  this.setState({...this.state, mapKeys: [...basemapHelper.pupMaps()], currentlySelected: 'PupControl'})
                })
              }
            }
          }}
        />
      </React.Fragment>
    )
  }

  protected getBasemapSearch(): JSX.Element {
    return (
      <React.Fragment>
        <input
          className="form-control"
          style={{display: ' inline-block', marginTop: '5px', width: '100%'}}
          type="text"
          placeholder="Търсене на карта"
          onChange={e => {
            const newVal = e.target.value //TrimCadFilter()
            this.setState({...this.state, mapSearchValue: newVal})
          }}
        />
      </React.Fragment>
    )
  }

  protected getBasemapPicker(): JSX.Element {
    return (
      <React.Fragment>
        <BasemapPicker
          mapKeys={this.state.mapKeys}
          basemap={this.props.basemap}
          mapDispatcher={this.props}
          maxStrech={'100%'}
          horizontal={true}
          search={this.state.mapSearchValue}
          pupSearch={this.state.pupSearch}
        />
      </React.Fragment>
    )
  }
  protected getLayerList(): JSX.Element {
    return (
      <React.Fragment>
        <div className="title">Изберете видими слоеве</div>
        <div>Ниво на увеличение: {this.props.zoom}</div>
        <LayerList
          zoom={this.props.zoom}
          layersDispatcher={this.props}
          layerInfos={this.props.featureLayers}
          hiddenGroupsCaches={this.props.hiddenGroupsCaches}
          visibleLayers={this.props.visibleLayers}
          layerListWithLegend={this.props.layerListWithLegend}
          sourcesImported={this.props.sourcesImported}
          dataQueries={this.props.dataQueries}
          vectorLayerImagesLoaded={this.props.vectorLayerImagesLoaded}
          dataQueryDispatcher={this.props.dataQueryDispatcher}
        />
      </React.Fragment>
    )
  }
  protected getLegend(): JSX.Element {
    return (
      <React.Fragment>
        <div className="title">Легенда</div>
        <Legend
          dataQueries={this.props.dataQueries}
          zoom={this.props.zoom}
          hiddenGroupsCaches={this.props.hiddenGroupsCaches}
          layersDispatcher={this.props}
          visibleLayers={this.props.visibleLayers}
          layerInfos={this.props.featureLayers}
          sourcesImported={this.props.sourcesImported}
          vectorLayerImagesLoaded={this.props.vectorLayerImagesLoaded}
          dataQueryDispatcher={this.props.dataQueryDispatcher}
        />
      </React.Fragment>
    )
  }

  protected getSearch(): JSX.Element {
    return (
      <React.Fragment>
        <div className="title">Търсене на адрес</div>
        <div className="search-container">
          <input
            className="form-control"
            style={{display: ' inline-block', margin: '5px', width: '70%'}}
            type="text"
            placeholder="Въведете адрес"
            onChange={e => {
              const newVal = e.target.value //TrimCadFilter()
              this.setState({...this.state, searchValue: newVal})
            }}
          />

          <button
            className="btn btn-primary"
            style={{
              display: ' inline-block',
              margin: '5px',
              width: '20%',
              border: 'none',
              textDecoration: 'none',
              padding: '10px',
              textAlign: 'center',
              fontSize: '13px'
            }}
            disabled={this.state.searchValue == ''}
            onClick={() => {
              if (this.state.searchValue == '') {
                return
              }
              const address = this.state.searchValue.replace(/"/g, ' ')
              const headers = {
                'Content-Type': 'application/json;charset=utf-8'
              }
              const data =
                '{"where":"upper(\\"Adr\\") LIKE \'' +
                address +
                '\' AND 1=1","outFields":["Id","Adr"],"orderByFields":["Id ASC"],"num":25,"start":0}'
              const config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: appConfig.urls.xyApiUrl + '/Common/Adress/Query',
                headers: headers,
                data: data
              }
              Axios.request(config).then(r => {
                if (r.data) {
                  this.setState({...this.state, searchResults: r.data})
                }
              })
            }}
          >
            Търси
          </button>

          <div className="search-results">
            {this.state.searchResults.map((result, index) => (
              <div
                key={index}
                className="search-result"
                style={{
                  cursor: 'pointer',
                  margin: '5px',
                  marginLeft: '0px',
                  border: '1px solid #ccc',
                  textAlign: 'left'
                }}
                onClick={() => {
                  this.goToAddress(index)
                }}
              >
                {result.Adr}
              </div>
            ))}
          </div>
        </div>
      </React.Fragment>
    )
  }

  // Placeholder for PUP-specific search; replace contents with the custom UI/logic you need.
  protected getPupSearch(): JSX.Element {
    return (
      <React.Fragment>
        <div>
          <div className="pup-search-container">
            <input
              className="form-control"
              style={{display: ' inline-block', marginTop: '5px', width: '34%'}}
              type="text"
              placeholder="Екатте"
              onChange={e => {
                const newVal = e.target.value
                this.setState({
                  ...this.state,
                  pupSearch: {...this.state.pupSearch, ekatte: newVal}
                })
              }}
            />
            <input
              className="form-control"
              style={{display: ' inline-block', marginTop: '5px', width: '33%'}}
              type="text"
              placeholder="Година"
              onChange={e => {
                const newVal = e.target.value
                this.setState({
                  ...this.state,
                  pupSearch: {...this.state.pupSearch, year: newVal}
                })
              }}
            />
            <input
              className="form-control"
              style={{display: ' inline-block', marginTop: '5px', width: '33%'}}
              type="text"
              placeholder="Квартал"
              onChange={e => {
                const newVal = e.target.value
                this.setState({
                  ...this.state,
                  pupSearch: {...this.state.pupSearch, quarter: newVal}
                })
              }}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }

  protected goToAddress(index: number) {
    const coords = [this.state.searchResults[index].Geometry.X, this.state.searchResults[index].Geometry.Y]
    getMapService().setCenter(coords)
    getMapService().setZoom(19)
    const point = new Point(coords)
    getMapService().drawing.flash([point])
  }

  render() {
    return (
      <div className="map-layer-controls">
        {this.props.hideLayerList ? null : this.getLayerList()}
        {window.appType == 'public' ? this.getSearch() : null}
        {this.props.hideBasemaps ? null : this.getBasemapDropdown()}
        {this.props.hideBasemaps ? null : this.getBasemapSearch()}
        {this.state.currentlySelected === 'PupControl' ? this.getPupSearch() : null}
        {this.props.hideBasemaps ? null : this.getBasemapPicker()}
        {this.props.hideLegend ? null : this.getLegend()}
      </div>
    )
  }
}

export const mapStateToProps = (state: IStore) => ({
  visibleTables: state.data.visibleTables,
  tabInfos: state.data.featureTables,
  mobile: state.application.mobile,
  loading: state.data.loading,
  basemap: state.map.basemap,
  featureLayers: state.layerInfos.featureLayerInfos,
  hiddenGroupsCaches: state.layerInfos.hiddenGroupsCaches,
  visibleLayers: state.layerInfos.visibleLayers,
  zoom: state.map.zoom,
  sourcesImported: state.map.sourcesImported,
  vectorLayerImagesLoaded: state.layerInfos.vectorLayerImagesLoaded,
  dataQueries: state.dataQueries
})
